import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'Angular/config/config.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class NotificationsSideMenuModule {
}
NotificationsSideMenuModule.ɵfac = function NotificationsSideMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsSideMenuModule)(); };
NotificationsSideMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NotificationsSideMenuModule });
NotificationsSideMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, CommonModule, ConfigModule, IconModule, TooltipModule] });
